import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invoice-selection" — drives the checkbox
// selection on Facturen > Zelf registraties kiezen. The bar with "Factureren"
// and "Elk apart" only shows once something is checked; with exactly one
// checked, "Factureren" invoices that one and "Elk apart" hides. Every row
// there belongs to one customer, so any selection can be bundled. Without an
// invoiceButton target it keeps the older enable/disable behaviour.
export default class extends Controller {
  static targets = ["selectAll", "checkbox", "individualButton", "bundleButton", "invoiceButton", "count", "row", "bar"]
  // `selected` is a template carrying a %{count} placeholder straight from the
  // locale file, so the count stays in the view's language.
  static values = { selected: String }

  connect() {
    this.recompute()
  }

  toggleAll() {
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = this.selectAllTarget.checked })
    this.recompute()
  }

  recompute() {
    const checked = this.checkboxTargets.filter((checkbox) => checkbox.checked)
    const bundleKeys = new Set(checked.map((checkbox) => checkbox.dataset.bundleKey))

    if (this.hasInvoiceButtonTarget) {
      this.invoiceButtonTarget.value = checked.length === 1 ? "individual" : "bundle"
      this.individualButtonTarget.hidden = checked.length === 1
      this.barTarget.hidden = checked.length === 0
    } else {
      this.individualButtonTarget.disabled = checked.length === 0
      this.bundleButtonTarget.disabled = !(checked.length >= 2 && bundleKeys.size === 1)
    }

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = checked.length > 0 && checked.length === this.checkboxTargets.length
    }
    this.countTarget.textContent = this.selectedValue.replace("%{count}", checked.length)

    this.rowTargets.forEach((row) => {
      const checkbox = row.querySelector('[data-invoice-selection-target="checkbox"]')
      row.classList.toggle("bg-brand-50/60", checkbox?.checked === true)
    })
  }
}
